import { registerPropertyTranslations } from './utils-editor';

/**
 * Bulk registers localizations for custom survey properties.
 * DO NOT LOAD in survey view-only mode, as it will throw an error because the creator chunk is not loaded.
 */
export function registerCustomPropertiesLocalization(): void {
  const propertyTranslations: Record<string, Record<string, string>> = {
    customSurveyPropAnon:
        {
        en: 'Anonymous',
          de: 'Anonym',
          hu: 'Névtelen',
          sl: 'Anonimno',
          hr: 'Anonimno',
        },
        customSurveyNoMail:
        {
        en: 'No mail field for contact details',
          de: 'Kein Mail Feld bei Kontaktdaten',
          hu: 'Nincs e-mail mező az elérhetőségekhez',
          sl: 'Ni polja za e-pošto za kontaktne podatke',
          hr: 'Nema polja za e-poštu za kontakt podatke',
        },
        customRemember:
        {
        en: 'Remember contact',
          de: 'Kontakt merken',
          hu: 'Emlékezzen a kapcsolatfelvételre',
          sl: 'Zapomni si kontakt',
          hr: 'Zapamti kontakt',
        },
        customShowScoreResultOnComplete:
        {
        en: 'Show score result on complete',
          de: 'Zeige Punkte Ergebnis bei Abschluss',
          hu: 'A teljesítéskor a pont megjelenítése',
          sl: 'Prikaži točke ob zaključku',
          hr: 'Prikaži bodove po završetku',
        },
        customValidForDays:
        {
        en: 'Valid for (days)',
          de: 'Gültig für Tag(e)',
          hu: 'Érvényes (nap)',
          sl: 'Velja (dnevi)',
          hr: 'Vrijedi (dana)',
        },
        customShowStillValidToast:
        {
        en: 'Still-valid notification',
          de: 'Noch-gültig Benachrichtigung',
          hu: 'Továbbra is érvényes értesítés',
          sl: 'Obvestilo je še vedno veljavno',
          hr: 'Još uvijek važeća obavijest',
        },
        customRunnableTimeStart:
        {
        en: 'Runnable Time Start',
          de: 'Ausführbare Zeit Start',
          hu: 'Futtatható idő Kezdés',
          sl: 'Izvedljiv čas Začetek',
          hr: 'Izvršno vrijeme Početak',
        },
        customRunnableTimeStop:
        {
        en: 'Runnable Time Stop',
          de: 'Ausführbare Zeit Stop',
          hu: 'Futtatható idő Befejezés',
          sl: 'Izvedljiv čas Konec',
          hr: 'Izvršno vrijeme Kraj',
        },
        customFutureMarkDoneDate:
        {
        en: 'Marker Done Date [min]',
          de: 'Marker Erledigt Datum [Min]',
          hu: 'Marker Befejezett Dátum (perc)',
          sl: 'Označevalnik Končan Datum (min)',
          hr: 'Označitelj Završeno Datum (min)',
        },
        isPhoneNumberAlarmEnabled:
        {
        en: 'Alarming enabled',
          de: 'Alarmierung aktiv',
          hu: 'Riasztás engedélyezve',
          sl: 'Alarmiranje omogočeno',
          hr: 'Alarmiranje uključeno',
        },
    };

  Object.entries(propertyTranslations).forEach(([propName, translations]) => {
      registerPropertyTranslations(propName, translations, 'de');
  });
}